<template>
    <div v-if="hasContent" :class="rootClass">
        <div v-for="fact in facts" :key="fact.label" class="flex flex-col">
            <span
                class="text-[11px] uppercase tracking-wide text-slate-400 dark:text-slate-500 font-semibold"
            >
                {{ fact.label }}
            </span>
            <span class="text-sm font-medium text-slate-800 dark:text-slate-100">
                {{ fact.value }}
            </span>
        </div>

        <div
            v-for="group in relationshipGroups"
            :key="group.label"
            class="flex flex-col"
        >
            <span
                class="text-[11px] uppercase tracking-wide text-slate-400 dark:text-slate-500 font-semibold"
            >
                {{ group.label }}
            </span>
            <div class="mt-1 flex flex-wrap gap-1.5">
                <a
                    v-for="item in group.items"
                    :key="item.id"
                    :href="urlFor(item)"
                    class="inline-flex items-center rounded bg-slate-100 dark:bg-slate-700 px-2 py-0.5 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-600"
                    :title="item.name"
                >
                    {{ item.iata_code || item.name }}
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    program: {
        type: Object,
        required: true,
    },
    variant: {
        type: String,
        default: 'mobile',
        validator: (v) => ['mobile', 'desktop'].includes(v),
    },
});

const facts = computed(() =>
    [
        { label: 'Alliance', value: props.program.alliance },
        { label: 'IATA Code', value: props.program.iata_code },
        {
            label: 'Award Space Released',
            value: props.program.award_release_days,
        },
    ].filter((fact) => fact.value)
);

const relationshipGroups = computed(() =>
    [
        {
            label: 'Also Bookable With',
            items: props.program.also_bookable_with || [],
        },
    ].filter((group) => group.items.length)
);

const hasContent = computed(
    () => facts.value.length > 0 || relationshipGroups.value.length > 0
);

const urlFor = (item) =>
    item.slug ? `/resources/transfer-partners-guide/${item.slug}` : '#';

const rootClass = computed(() =>
    props.variant === 'desktop'
        ? 'mt-6 flex flex-wrap gap-x-10 gap-y-4'
        : 'mt-4 flex flex-wrap gap-x-8 gap-y-3'
);
</script>
